import { ServiceFetch } from '../service-fetch'

export default class SaleCloseShiftModel extends ServiceFetch {
    getSaleCloseShiftBy = (data) => this.authFetch({
        url: 'sale-close-shift/getSaleCloseShiftBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getSaleCloseShiftByCode = (data) => this.authFetch({
        url: 'sale-close-shift/getSaleCloseShiftByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getAdviseApproveSaleCloseShift = (data) => this.authFetch({
        url: 'sale-close-shift/getAdviseApproveSaleCloseShift',
        method: 'POST',
        body: JSON.stringify(data),
    })
}